import { render, staticRenderFns } from "./SkyBtn.vue?vue&type=template&id=426488f8&scoped=true"
import script from "./SkyBtn.vue?vue&type=script&lang=js"
export * from "./SkyBtn.vue?vue&type=script&lang=js"
import style0 from "./SkyBtn.vue?vue&type=style&index=0&id=426488f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426488f8",
  null
  
)

export default component.exports